import React from 'react';

import { ActionIcon, Indicator } from '@mantine/core';
import { IconShoppingCart } from '@tabler/icons-react';

interface ShoppingCartWithBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  onClick: () => void;
  count: number;
}

const ShoppingCartWithBadge = ({ onClick, count, ...props }: ShoppingCartWithBadgeProps): JSX.Element => {
  return (
    <Indicator
      label={count}
      size={18}
      disabled={count === 0}
      color='red'
      offset={7}
      styles={{ indicator: { fontWeight: 'bold' } }}
      {...props}
    >
      <ActionIcon onClick={onClick} size='xl'>
        <IconShoppingCart color='black' />
      </ActionIcon>
    </Indicator>
  );
};

export default ShoppingCartWithBadge;
